import navConfig from '../components/SideBar/config';
import { HAS_VALUE_PERMISSION_LEVELS, VALUE_PERMISSION_LEVELS } from './constants/permissions';

class Permissions {
  constructor() {
    this.resourceAccess = {};
  }

  updateResourceAccess = () => {
    const decodedToken = JSON.parse(localStorage.getItem('decodedToken'));
    this.resourceAccess = decodedToken?.resource_access || {};
  };

  levelsRegExp = new RegExp(`^(${HAS_VALUE_PERMISSION_LEVELS.join('|')})`); // /^(get|read|...|manage)/

  // Examples
  // for 'readRealms' return {level: 'read', valueLevel: 1,  section: 'Realms' }
  // for 'delete' return {level: 'delete', valueLevel: 4,  section: '' }
  // for 'licenses' return null
  parseLevel = (level = '') => {
    const [levelPermission] = level.match(this.levelsRegExp) || [];

    if (!levelPermission) return null;

    return {
      level: levelPermission,
      valueLevel: VALUE_PERMISSION_LEVELS[levelPermission],
      section: level.replace(levelPermission, ''),
    };
  };

  checkRestriction = (restriction) => {
    if (!restriction) return true;

    const { resource, level } = restriction;

    const parsedLevel = this.parseLevel(level);

    const { roles: guaranteedAccessLevels } = this.resourceAccess[resource] || {};

    if (!parsedLevel) {
      return guaranteedAccessLevels?.includes(level);
    }

    return guaranteedAccessLevels?.some((guaranteedAccessLevel) => {
      const parsedGuaranteedAccessLevel = this.parseLevel(guaranteedAccessLevel);

      return (
        parsedGuaranteedAccessLevel &&
        parsedGuaranteedAccessLevel.section === parsedLevel.section &&
        parsedGuaranteedAccessLevel.valueLevel >= parsedLevel.valueLevel
      );
    });
  };

  checkAllRestrictions = (restrictions) => {
    if (Array.isArray(restrictions)) return restrictions.every(this.checkRestriction);

    return this.checkRestriction(restrictions);
  };

  checkAtLeasOneRestrictions = (restrictions) => {
    if (Array.isArray(restrictions)) return restrictions.some(this.checkRestriction);

    return this.checkRestriction(restrictions);
  };

  // Examples
  // for restrictions structure like [[{1}, {2}]], [{3}]] access guaranteed if ({1} and {2} = true) or {3} = true
  // for restrictions structure like [{1}, {2}, {3}] access guaranteed if {1} and {2} and {3} = true
  checkSideBarRestrictions = (restrictions) =>
    Array.isArray(restrictions?.[0])
      ? restrictions.some(this.checkAllRestrictions)
      : this.checkAllRestrictions(restrictions);

  getAllowedSideBarItems = () => {
    this.updateResourceAccess();

    return navConfig
      .map(({ items, ...rest }) => ({
        ...rest,
        items: items.filter(
          ({ restrictions }) => !restrictions || this.checkSideBarRestrictions(restrictions),
        ),
      }))
      .filter(({ items }) => !!items.length);
  };
}

const permissions = new Permissions();

export default permissions;
